"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var NotificationTimed_scss_1 = require("./NotificationTimed.scss");
var IconSvg_1 = require("../IconSvg");
var Join_1 = require("../../../helpers/Functions/Join");
var NotificationTimed = function (_a) {
    var children = _a.children, onClick = _a.onClick, style = _a.style, testId = _a.testId, className = _a.className, hide = _a.hide, _b = _a.timeout, timeout = _b === void 0 ? 30000 : _b, _c = _a.shown, shown = _c === void 0 ? true : _c;
    React.useEffect(function () {
        if (shown && isFinite(timeout)) {
            setTimeout(hide, timeout);
        }
    }, [shown]);
    return shown ? (React.createElement("div", { role: "alert", className: Join_1.join(NotificationTimed_scss_1.notificationBox, "bg-ui-dark-gray", "flex", "flex-items-center", "justify-between", "rel", className), style: style, onClick: onClick, "data-testid": testId },
        React.createElement("span", { className: "hidden-spoken" }, children),
        React.createElement("span", { "aria-hidden": true, className: Join_1.join(NotificationTimed_scss_1.notificationText, "section-text-3", "color-ui-white", "pad-l-xs") }, children),
        React.createElement("button", { role: "button", className: Join_1.join(NotificationTimed_scss_1.notificationButton, "absolute", "right", "top"), onClick: hide },
            React.createElement(IconSvg_1.default, { ariaHidden: false, ariaLabel: "Close Notification", className: NotificationTimed_scss_1.notificationIcon, colorClass: "color-ui-gray", svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"svg-base\" d=\"M11.33 6.38L9.21 8.5l2.12 2.12-.71.71L8.5 9.21l-2.12 2.12-.71-.71L7.79 8.5 5.67 6.38l.71-.71L8.5 7.79l2.12-2.12z\"/></svg>" })))) : null;
};
exports.default = NotificationTimed;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/NotificationTimed/NotificationTimed.js
// module id = 1791
// module chunks = 8